<template>
  <div class="page-wrapper">
    <the-email-header />
    <div class="mt-32">
      <TheCaseModificationContent />
    </div>
  </div>
</template>

<script setup lang="ts" name="TheEmailModificationTemplate">
import { onMounted, onUnmounted } from "vue";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import TheEmailHeader from "@/components/email/TheEmailHeader.vue";
import TheCaseModificationContent from "./TheCaseModificationContent.vue";

const route = useRoute();
const { locale } = useI18n();
let savedLocale: string | null = null;

onMounted(() => {
  const { lang } = route.query;
  if (lang) {
    savedLocale = locale.value;
    locale.value = lang as string;
  }
});

onUnmounted(() => {
  if (savedLocale) {
    locale.value = savedLocale;
  }
});
</script>

<style>
.page-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
</style>